import * as React from 'react';

var _path, _g, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgAddAddress = function SvgAddAddress(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 80 80"
    }, props), /*#__PURE__*/ React.createElement("mask", {
        id: "mask0_66_24917",
        width: 80,
        height: 80,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "alpha"
        }
    }, _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#D9D9D9",
        d: "M0 0h80v80H0z"
    }))), _g || (_g = /*#__PURE__*/ React.createElement("g", {
        mask: "url(#mask0_66_24917)"
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: 44,
        cy: 44,
        r: 30,
        fill: "url(#paint0_linear_66_24917)",
        fillOpacity: 0.16
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_66_24917)",
        d: "M40 70q-6.316 0-11.803-2.337-5.485-2.336-9.505-6.355t-6.356-9.505Q10 46.316 10 40t2.336-11.802 6.356-9.506q4.02-4.02 9.505-6.356Q33.684 10 40 10t11.802 2.336 9.506 6.356q4.02 4.02 6.355 9.506Q70 33.683 70 40v3.064q0 4.15-2.843 6.947t-7.016 2.797q-3.32 0-5.635-1.683-2.314-1.682-3.346-4.67-1.845 2.898-4.423 4.625Q44.16 52.808 40 52.808q-5.346 0-9.087-3.731t-3.74-9.11q0-5.377 3.74-9.095T40 27.154q5.346 0 9.087 3.718t3.74 9.136v3.063q0 2.967 2.131 5.07 2.132 2.103 5.215 2.103 3 0 5.132-2.103 2.13-2.103 2.13-5.07V40q0-11.32-8.057-19.378T40 12.564t-19.378 8.058T12.564 40t8.058 19.378T40 67.436h15.91q.57 0 .926.357t.356.926q0 .57-.356.925-.357.356-.926.356zm.004-19.756q4.284 0 7.272-2.967Q50.263 44.31 50.263 40q0-4.34-2.991-7.31-2.992-2.972-7.276-2.972t-7.272 2.978q-2.987 2.977-2.987 7.327 0 4.265 2.991 7.243t7.276 2.978"
    }))), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_66_24917",
        x1: 14.627,
        x2: 73.165,
        y1: 44,
        y2: 44,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_66_24917",
        x1: 10.627,
        x2: 69.165,
        y1: 40,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })))));
};

export { SvgAddAddress as ReactComponent };
//# sourceMappingURL=AddAddress.svg.es.js.map
